import { useContext } from 'react';
import { Badge } from '@mui/joy';
import { LayoutContext } from '../context';

export default function UnreadChatBadge({ chatId, children }) {
  const { getChatUnread } = useContext(LayoutContext);
  const count = getChatUnread?.(chatId) || 0;
  return <Badge badgeContent={count > 99 ? '99+' : count} invisible={count === 0}
    color="danger" size="sm" sx={{ '& .MuiBadge-badge': { pointerEvents: 'none' } }}>
    {children}
  </Badge>;
}